import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";
import { VscDiffAdded } from "react-icons/vsc";
import { BiTrash } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from 'yup'
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import allowNumbersOnly, { allowAlphabetAndSpacesOnly, AllowFloats, handleAutoCapitalizeallowNumAlphat, handlePaste, handleTestPaste } from "../CommonUtils/CommonValidations";
import moment from 'moment';
import { viewImage } from "../CommonUtils/viewImage";
import { getCasts, getCourses, getDesignations, getEmpTypes, getQualifications, getReligions } from "../Reducers/AffiliationCommonservice";
import { AADHAR_VALIDATION, ERROR_MSG, IFSC_VALIDATION, MOBILE_VALIDATION, NUMERIC, PAN_VALIDATION } from "../CommonUtils/contextVariables";
import * as bie from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import { ImagePdfBucket } from "../CommonUtils/ImagesBase64";
import { failureAlert } from "../CommonUtils/SweetAlerts";
import Alert from 'react-bootstrap/Alert';
import CommonFormHeading from "../CommonUtils/CommonFormHeading";

export default function TeachingStaffDetails() {
    const hasFetchedData = useRef(false)
    const [spec, setSpec] = useState([])
    const empId = sessionStorage.getItem('empId')
    const dispatch = useDispatch()
    const religionList = useSelector((state) => state?.commonMastersReducer?.religionList);
    const caste = useSelector((state) => state?.commonMastersReducer?.casts);
    const desig = useSelector((state) => state?.commonMastersReducer?.designations);
    const emp = useSelector((state) => state?.commonMastersReducer?.empTypes);
    const quall = useSelector((state) => state?.commonMastersReducer?.qualifications);
    const course = useSelector((state) => state?.commonMastersReducer?.courses);
    const navigate = useNavigate();

    const validationSchema = Yup.object({
        empName: Yup.string().required(ERROR_MSG).nullable(),
        gender: Yup.string().required(ERROR_MSG).nullable(),
        aadhar: Yup.string().matches(AADHAR_VALIDATION, 'Invalid Aadhaar').required(ERROR_MSG).nullable(),
        dateOfBirth: Yup.date().required(ERROR_MSG).nullable(),
        designationId: Yup.string().required(ERROR_MSG),
        otherDesignation: Yup.string().when('designationId', {
            is: (designationId) => designationId === '99',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired(),
        }),
        employeeType: Yup.string().required(ERROR_MSG).nullable(),
        courseGroupCode: Yup.string().required(ERROR_MSG).nullable(),
        employeeMobileNo: Yup.string().matches(MOBILE_VALIDATION, 'Invalid mobile number').required(ERROR_MSG),
        employeeEmail: Yup.string().email('Invalid email format').required(ERROR_MSG),
        panNumber: Yup.string().required(ERROR_MSG).matches(PAN_VALIDATION, 'Invalid PAN number'),
        sscNo: Yup.string().required(ERROR_MSG).nullable(),
        payScale: Yup.string().required(ERROR_MSG).nullable(),
        employeePhoto: Yup.mixed().required(ERROR_MSG).nullable(),
        religion: Yup.string().required(ERROR_MSG).nullable(),
        caste: Yup.string().required(ERROR_MSG).nullable(),
        accountNumber: Yup.string().required(ERROR_MSG).matches(/^\d{9,18}$/, 'Invalid account number'),

        ifscCode: Yup.string().matches(IFSC_VALIDATION, 'Ivalid IFSC Code').required(ERROR_MSG),
        qualifiedEts: Yup.string().required(ERROR_MSG),
        qualifiedEtsPhoto: Yup.string().when('qualifiedEts', {
            is: (designationId) => designationId === 'true',
            then: Yup.string().required(ERROR_MSG),
            otherwise: Yup.string().notRequired(),
        }),
        articlesPatents: Yup.string().required(ERROR_MSG),
        noPhdReg: Yup.string().matches(NUMERIC, "Invalid Number").required(ERROR_MSG).nullable(),
        noPhdAwarded: Yup.string().matches(NUMERIC, "Invalid Number").required(ERROR_MSG).nullable(),
        articlesPublished: Yup.string().matches(NUMERIC, "Invalid Number").required(ERROR_MSG).nullable(),
        patentsGranted: Yup.string().matches(NUMERIC, "Invalid Number").required(ERROR_MSG).nullable(),

        dateOfJoining: Yup.date().required(ERROR_MSG).nullable(),
        experience: Yup.string().required(ERROR_MSG).nullable(),
        employeePwd: Yup.string().required(ERROR_MSG).nullable(),

        qualifications: Yup.array().of(
            Yup.object().shape({
                qualificationId: Yup.string().required(ERROR_MSG).nullable(),
                specializationCode: Yup.string().required(ERROR_MSG).nullable(),
                phdSpecialization: Yup.string().notRequired(),
                certificateNo: Yup.string().required(ERROR_MSG).nullable(),
                percentage: Yup.number().min(0, 'Percentage cannot be less than 0').max(100, 'Percentage cannot be more than 100').required(ERROR_MSG).nullable(),
                passedYear: Yup.string().required(ERROR_MSG).nullable(),
                universityName: Yup.string().required(ERROR_MSG).nullable(),
                qualificationDocumentPhoto: Yup.mixed().required(ERROR_MSG).nullable(),
                otherCourse: Yup.string().when('qualificationId', {
                    is: (qualificationId) => qualificationId === '999',
                    then: Yup.string().required(ERROR_MSG).nullable(),
                    otherwise: Yup.string().notRequired(),
                }),
                otherSpecialization: Yup.string().when('specializationCode', {
                    is: (specializationCode) => specializationCode === '999',
                    then: Yup.string().required(ERROR_MSG).nullable(),
                    otherwise: Yup.string().notRequired(),
                }),
                universityLocation: Yup.string().required(ERROR_MSG).nullable(),
            })
        ),

        experiences: Yup.array().when('experience', {
            is: (exp) => {
                return exp === true || exp === "true";
            },
            then: Yup.array().of(
                Yup.object().shape({
                    organizationName: Yup.string().required(ERROR_MSG).nullable(),
                    experienceType: Yup.string().required(ERROR_MSG).nullable(),
                    institutionName: Yup.string().required(ERROR_MSG).nullable(),
                    employmentFromYear: Yup.string().required(ERROR_MSG).nullable(),
                    employmentToYear: Yup.string().required(ERROR_MSG).nullable(),
                    designationHeld: Yup.string().required(ERROR_MSG).nullable(),
                    yearsOfExperience: Yup.string().required(ERROR_MSG).nullable(),
                    // experienceDocumentPhoto: Yup.string().required(ERROR_MSG),
                    experienceDocumentPhoto: Yup.string()
                        .required(ERROR_MSG)
                        .test('check-zero', ERROR_MSG, (value) => {
                            return value !== "0"; // Fail validation if the value is "0"

                        })
                })
            ),
            otherwise: Yup.array().notRequired(),
        }),

        memberships: Yup.array().when('articlesPatents', {
            is: (exp) => exp === "true", then: Yup.array().of(Yup.object().shape({
                membershipName: Yup.string().required(ERROR_MSG),
                membershipId: Yup.string().required(ERROR_MSG),
                membershipFromYear: Yup.string().required(ERROR_MSG),
                membershipDocPhoto: Yup.string().required(ERROR_MSG),
            })
            ),
            otherwise: Yup.array().notRequired(),
        }),

    });

    const location = useLocation();
    const changebuttonname = location.state?.update === "Update" ? "Update" : "Submit"
    const action = location.state?.action;

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            empId: '',
            empName: '',
            gender: '',
            aadhar: '',
            dateOfBirth: '',
            designationId: '',
            otherDesignation: '',
            employeeType: '',
            courseGroupCode: '',
            employeeMobileNo: '',
            employeeEmail: '',
            panNumber: '',
            sscNo: '',
            payScale: '',
            employeePhoto: '',
            religion: '',
            caste: '',
            accountNumber: '',
            ifscCode: '',
            qualifiedEts: '',
            qualifiedEtsPhoto: '',
            articlesPatents: '',
            noPhdReg: '',
            noPhdAwarded: '',
            employeePwd: '',
            articlesPublished: '',
            patentsGranted: '',
            dateOfJoining: '',
            experience: '',
            experiences: [
                {
                    slNo: '',
                    organizationName: '',
                    experienceType: '',
                    institutionName: '',
                    employmentFromYear: '',
                    employmentToYear: '',
                    designationHeld: '',
                    yearsOfExperience: '',
                    experienceDocumentPhoto: '',
                }
            ],
            qualifications: [
                {
                    qualificationId: '',
                    specializationCode: '',
                    phdSpecialization: '',
                    certificateNo: '',
                    percentage: '',
                    passedYear: '',
                    universityName: '',
                    qualificationDocumentPhoto: '',
                    otherCourse: '',
                    otherSpecialization: '',
                    universityLocation: ''
                }
            ],
            memberships: [
                {
                    membershipName: '',
                    membershipId: '',
                    membershipFromYear: '',
                    membershipDocPhoto: '',
                }
            ],
        },
        validationSchema: validationSchema,
        onSubmit: (val) => {
            Swal.fire({
                title: 'Are you sure?',
                // text: 'Do you want to submit the form?',
                text: `Do you want to ${changebuttonname.toLowerCase()} the form?`, // Dynamically change text based on the button name

                icon: 'warning',
                showCancelButton: true,
                // confirmButtonText: 'Yes, submit!',
                confirmButtonText: `Yes, ${changebuttonname.toLowerCase()}!`, // Dynamically change button text based on the button name

                cancelButtonText: 'No, cancel',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const updatedExperiences = formik.values.experiences.map(item => ({
                        ...item,
                        experience: formik.values.experience
                    }));
                    const body = { ...val, experiences: updatedExperiences };

                    let url = config.url.API_URL + 'TeachingDetails';
                    CommonAxiosPost(url, body).then((res) => {
                        if (res?.data?.scode === '01') {
                            const successMessage = changebuttonname === "Submit" ? res?.data?.sdesc : "Successfully updated";
                            Swal.fire(successMessage, '', 'success').then((resp) => {
                                navigate("/TeachingStaffDetailsReport")
                            });
                        } else {
                            failureAlert("Failed to submit")

                        }
                    });
                } else {
                    console.log('Form submission canceled');
                }
            });
        }

    });

    function GetData() {
        if (empId) {
            try {
                let url = config.url.API_URL + `getEditData/${empId}`
                CommonAxiosGet(url, dispatch).then((res) => {
                    if (res?.data?.scode === '01') {
                        let data = res?.data?.editdata[0]
                        formik.setFieldValue('empName', data?.emp_name)
                        formik.setFieldValue('empId', data?.emp_id)
                        const dateString = data?.dateofbirth;
                        if (dateString) {
                            const dateParts = dateString.split('/');
                            const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
                            formik.setFieldValue('dateOfBirth', formattedDate);
                        } else {
                            console.log('Invalid date format');
                        }
                        formik.setFieldValue('gender', data?.gender)
                        formik.setFieldValue('aadhar', data?.aadhar)
                        formik.setFieldValue('panNumber', data?.pan_number)
                        formik.setFieldValue('accountNumber', data?.ac_number)
                        formik.setFieldValue('ifscCode', data?.ifsc_code)
                        formik.setFieldValue('employeeMobileNo', data?.emp_mobileno)
                        formik.setFieldValue('employeeEmail', data?.emp_email)
                        formik.setFieldValue('employeePhoto', data?.emp_photo)
                        formik.setFieldValue('payScale', data?.pay_scale)
                        formik.setFieldValue('religion', data?.religion)
                        formik.setFieldValue('caste', data?.caste)
                        formik.setFieldValue('designationId', data?.desg_id)
                        if (data?.desg_id == 99) {
                            formik.setFieldValue('otherDesignation', data?.other_desg || "");
                        } else {
                            formik.setFieldValue('otherDesignation', "");
                        }
                        formik.setFieldValue('employeeType', data?.emp_type)
                        formik.setFieldValue('courseGroupCode', data?.course_group_code)
                        const dateStringg = data?.date_of_joining;
                        if (dateString) {
                            const dateParts = dateStringg.split('/');
                            const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
                            formik.setFieldValue('dateOfJoining', formattedDate);
                        } else {
                            console.log('Invalid date format');
                        }
                        formik.setFieldValue('sscNo', data?.ssc_no)
                        formik.setFieldValue('qualifiedEts', data?.quailified_ets === true ? 'true' : data?.quailified_ets === false ? 'false' : null)
                        formik.setFieldValue('qualifiedEtsPhoto', data?.quailified_ets_photo)
                        formik.setFieldValue('employeePwd', data?.emp_pwd)
                        // formik.setFieldValue('experience', data?.experience?.toString() || '');
                        formik.setFieldValue('articlesPatents', data?.articles_patents === true ? 'true' : data?.articles_patents === false ? 'false' : null)
                        formik.setFieldValue('noPhdReg', data?.no_phd_reg)
                        formik.setFieldValue('noPhdAwarded', data?.no_phd_awarded)
                        formik.setFieldValue('articlesPublished', data?.articles_published)
                        formik.setFieldValue('patentsGranted', data?.patents_granted)
                    }
                })
            } catch (error) { }
            try {
                let urll = config.url.API_URL + `getExpData/${empId}`
                CommonAxiosGet(urll, dispatch).then((res) => {
                    if (res?.data?.scode === '01') {

                        const formatDate = (dateStr) => {
                            if (!dateStr) return '';
                            const [day, month, year] = dateStr.split('/'); // Split based on "dd/mm/yyyy"
                            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`; // Convert to "yyyy-mm-dd"
                        };
                        formik.setFieldValue('experience', res?.data?.expdata[0]?.experience.toString() || '')

                        const expDetails = res?.data?.expdata.length > 0
                            ? res?.data?.expdata.map((exp) => ({
                                organizationName: exp?.organization_name || '',
                                experienceType: exp?.experience_type || '',
                                institutionName: exp?.institution_name || '',
                                employmentFromYear: formatDate(exp?.employment_from_year) || '',
                                employmentToYear: formatDate(exp?.employment_to_year) || '',
                                designationHeld: exp?.designation_held || '',
                                yearsOfExperience: exp?.years_of_exp || '',
                                experienceDocumentPhoto: exp?.exp_doc_photo || '',
                            }))
                            : [{
                                organizationName: '',
                                experienceType: '',
                                institutionName: '',
                                employmentFromYear: '',
                                employmentToYear: '',
                                designationHeld: '',
                                yearsOfExperience: '',
                                experienceDocumentPhoto: '',
                            }];

                        formik.setFieldValue('experiences', expDetails);

                    }
                })
            } catch (err) { }
            try {
                let urlll = config.url.API_URL + `getQualData/${empId}`
                CommonAxiosGet(urlll, dispatch).then((res) => {
                    if (res?.data?.scode === '01') {
                        let qualData = res?.data?.qualdata?.length > 0 ? res?.data?.qualdata.map((qual, i) => {
                            GetSpecializations(qual?.qualification_id, i)
                            let passedYearFormatted = '';
                            const passedYearString = qual?.passed_year;
                            if (passedYearString) {
                                const dateParts = passedYearString.split('/');
                                if (dateParts.length === 3) {
                                    passedYearFormatted = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
                                } else {
                                    console.log('Invalid passed_year format');
                                }
                            }
                            return {
                                qualificationId: qual?.qualification_id?.toString(),
                                specializationCode: qual?.specialization_code.toString(),
                                phdSpecialization: '',
                                certificateNo: qual?.certificate_no,
                                percentage: qual?.percentage,
                                passedYear: passedYearFormatted,
                                universityName: qual?.univ_name,
                                qualificationDocumentPhoto: qual?.quali_doc_photo,
                                otherCourse: qual?.other_course,
                                otherSpecialization: qual?.other_specialization,
                                universityLocation: qual?.univ_location
                            };
                        }) : ('');

                        formik.setFieldValue('qualifications', qualData)

                    }
                })
            } catch (err) { }
            try {
                let urllll = config.url.API_URL + `getMemData/${empId}`
                CommonAxiosGet(urllll, dispatch).then((res) => {
                    if (res?.data?.scode === '01') {
                        const formatDate = (dateStr) => {
                            if (!dateStr) return '';
                            const parts = dateStr.split('/');
                            if (parts.length !== 3) return '';
                            const [day, month, year] = parts;
                            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
                        };
                        const memDetails = res?.data?.memdata.length > 0
                            ? res?.data?.memdata.map((mem) => ({
                                membershipName: mem?.membership_name || '',
                                membershipId: mem?.membership_id || '',
                                membershipFromYear: formatDate(mem?.membership_from_year) || '',
                                membershipDocPhoto: mem?.membership_doc_photo || '',
                            }))
                            : [{
                                membershipName: '',
                                membershipId: '',
                                membershipFromYear: '',
                                membershipDocPhoto: '',
                            }];

                        formik.setFieldValue('memberships', memDetails);
                    }
                })
            } catch (err) { }
        }
    }
    function GetSpecializations(courseCatId, index) {
        if (courseCatId === "999") {
            formik.setFieldValue(`qualifications[${index}].otherCourse`, '');
        }
        let url = config.url.API_URL + `getCourseSpecilization/${courseCatId}`;
        CommonAxiosGet(url, dispatch).then((res) => {
            if (res?.data?.scode === '01') {
                setSpec(prevSpecs => {
                    const updatedSpecs = [...prevSpecs];
                    updatedSpecs[index] = res?.data?.Specilization;
                    return updatedSpecs;
                });
            } else {
                setSpec(prevSpecs => {
                    const updatedSpecs = [...prevSpecs];
                    updatedSpecs[index] = [];
                    return updatedSpecs;
                });
            }
        });
    }

    function GetDataa(update) {
        navigate('/TeachingStaffDetailsReport', { state: { update: update } })

    }


    function GetAadhar(aadhar) {
        if (aadhar?.length === 12) {
            let url = `${config?.url?.API_URL}checkAadhar/${aadhar}`;
            CommonAxiosGet(url).then((res) => {
                if (res?.data) {
                    if (res?.data?.count > 0) {
                        Swal.fire("This Aadhaar is already registered.", '', 'info').then(() => {
                            formik?.setFieldValue("aadhar", "");
                        });
                    }
                } else { console.log("Api Data Not Found") }
            });
        }
    }
    function CheckPanNum(pan) {
        if (pan?.length === 10) {
            let url = `${config?.url?.API_URL}checkPan/${pan}`;
            CommonAxiosGet(url).then((res) => {
                if (res?.data) {
                    if (res?.data?.count > 0) {
                        Swal.fire("This PAN Number is already registered.", '', 'info').then(() => {
                            formik?.setFieldValue("panNumber", "");
                        });
                    }
                } else { console.log("Api Data Not Found") }
            });
        }
    }


    useEffect(() => {
        if (!hasFetchedData.current) {
            getReligions();
            getDesignations();
            getEmpTypes();
            getQualifications();
            getCourses();

        }
        hasFetchedData.current = true
        if (changebuttonname === "Submit") {
            formik?.resetForm()
        } else {
            GetData();
        }


    }, [])


    return (
        <>
            <div className="affl-newdiv px-1">
                <bie.Container fluid className="px-1">
                    <FormikProvider value={formik}>
                        <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit} className="affl-form" >

                            <CommonFormHeading heading={"Teaching Staff Details"} />

                            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5 ">
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11} className='mb-2'></bie.Col>


                                    <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className='mb-2'>

                                        <button type='button' className='btn btn-success btn-sm ml-auto' onClick={() => GetDataa("Update")}>Update/View Staff Details</button>
                                    </bie.Col>
                                </bie.Row>
                                <Alert variant="danger" className='affl-alert pt-3' >
                                    <p className="mb-0"> Note:  Please note that Aadhar based Bio-Metric Authentication will be done for all the Faculty.<br />
                                        Faculty Registration will be considered as completed only upon the Successful completion of Bio-Metric Authentication.</p>
                                </Alert>
                                <bie.Row className="px-2 my-3">
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} >
                                        <bie.InputGroup >
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>Employee Name</label>
                                            <Field type="text" name="empName" className="form-control mb-2 " placeholder='Employee Name' maxLength="80" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e) }}
                                                onPaste={(e) => handleTestPaste(e)} />
                                            <ErrorMessage name="empName" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3}  >
                                        <bie.InputGroup>
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>Date Of Birth</label>
                                            <Field
                                                type="date"
                                                name="dateOfBirth"
                                                className="form-control mb-2" onKeyDown={(e) => { e.preventDefault() }}
                                                max={(() => {
                                                    const today = new Date();
                                                    today.setFullYear(today.getFullYear() - 18);
                                                    return today.toISOString().split("T")[0];
                                                })()}
                                            />
                                            <ErrorMessage name="dateOfBirth" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} >
                                        <bie.InputGroup>
                                            <label classname='mb-1' ><b style={{ color: 'red' }}>* </b>Gender</label>
                                            <div className=''>
                                                <Field type="radio" name="gender" value='Male' />&nbsp;Male&emsp;
                                                <Field type="radio" name="gender" value='Female' />&nbsp;Female
                                            </div>
                                            <ErrorMessage name="gender" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} >
                                        <bie.InputGroup >
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>Aadhaar </label>
                                            <Field type="text" name="aadhar" className="form-control mb-2" placeholder='Aadhaar' maxLength='12' onPaste={(e) => handlePaste(e)}
                                                onKeyUp={(e) => GetAadhar(e.target?.value)}
                                                onKeyPress={(e) => { allowNumbersOnly(e) }}
                                            />
                                            <ErrorMessage name="aadhar" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} >
                                        <bie.InputGroup>
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>PAN Number</label>
                                            <Field type="text" name="panNumber" className='form-control' maxLength="10" onKeyUp={(e) => {
                                                const capitalizedValue = e.target.value.toUpperCase();
                                                formik.setFieldValue('panNumber', capitalizedValue);
                                                CheckPanNum(e.target?.value)
                                            }}
                                            />
                                            <ErrorMessage name="panNumber" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3}>
                                        <bie.InputGroup >
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>A/C Number </label>
                                            <Field type="text" name="accountNumber" className="form-control mb-2" placeholder='' maxLength='18' onPaste={(e) => handlePaste(e)}
                                                onKeyPress={(e) => allowNumbersOnly(e)} />
                                            <ErrorMessage name="accountNumber" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3}>
                                        <bie.InputGroup >
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>IFSC Code </label>
                                            <Field type="text" name="ifscCode" className="form-control mb-2" maxLength="11" onKeyPress={(e) => { handleAutoCapitalizeallowNumAlphat(e) }} />
                                            <ErrorMessage name="ifscCode" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3}>
                                        <bie.InputGroup>
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>Mobile No</label>
                                            <Field type="text" name="employeeMobileNo" className='form-control' onPaste={(e) => handlePaste(e)}
                                                maxLength='10' onKeyPress={(e) => allowNumbersOnly(e)} />
                                            <ErrorMessage name="employeeMobileNo" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3}>
                                        <bie.InputGroup>
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>Email</label>
                                            <Field type="text" name="employeeEmail" className='form-control' placeholder='mail@gmail.com' />
                                            <ErrorMessage name="employeeEmail" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3}>
                                        <bie.InputGroup>
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>Employee Photo</label>
                                            <div className="d-flex align-items-center">

                                                <input type="file" className="form-control mb-2" name={`employeePhoto`} accept="image/*"
                                                    onChange={(e) => {
                                                        let filename = `employeePhoto_upload`;
                                                        let path = "/Uploads/AffiliationPDFs/2024/";
                                                        ImagePdfBucket(e, formik, path, `employeePhoto`, filename, "image");
                                                    }}
                                                />
                                                {/* &emsp; */}
                                                {formik?.values?.employeePhoto && (<button type='button' onClick={() => viewImage(formik?.values?.employeePhoto)} className="btn btn-primary"> <FaEye size={20} /> </button>)}
                                                <ErrorMessage name="employeePhoto" component="div" className="text-error" />
                                            </div>
                                        </bie.InputGroup>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3}>
                                        <bie.InputGroup>
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>Monthly Salary</label>
                                            <Field type="text" name="payScale" className='form-control' placeholder='Monthly Salary' maxLength="6" onPaste={(e) => handlePaste(e)}
                                                onKeyPress={(e) => allowNumbersOnly(e)} />

                                            <ErrorMessage name="payScale" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3}>
                                        <bie.InputGroup >
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>Religion</label>
                                            <Field as="select" name="religion" className="form-control mb-2" onChange={(e) => getCasts(e.target?.value)} >
                                                <option value=''>--select--</option>
                                                {religionList && religionList !== "No data found" && religionList?.map((rel, i) => (
                                                    <option value={rel?.religionid}>{rel?.religiondesc}</option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="religion" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3}>
                                        <bie.InputGroup >
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>Social Background</label>
                                            <Field as="select" name="caste" className="form-control mb-2" >
                                                <option value=''>--select--</option>
                                                {caste && caste !== "No data found" && caste.map((caste, i) => (
                                                    <option value={caste?.caste_code}>{caste?.caste_desc}</option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="caste" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3}>
                                        <bie.InputGroup >
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>Designation</label>
                                            <Field as="select" name="designationId" className="form-control mb-2" onChange={() => formik.setFieldValue(`otherDesignation`, '')}>
                                                <option value=''>--select--</option>
                                                {desig && desig !== "No data found" && desig?.map((desig, i) => (
                                                    <option value={desig?.designation_id}>{desig?.designation_name}</option>
                                                ))}
                                                {desig && <option value="99">Others</option>}
                                            </Field>
                                            <ErrorMessage name="designationId" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                    {formik?.values?.designationId == 99 && (
                                        <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3}>
                                            <bie.InputGroup>
                                                <label classname='mb-1'><b style={{ color: 'red' }}>* </b>Others - Please Specify</label>
                                                <Field type="text" name="otherDesignation" className='form-control' placeholder='Others - Please Specify' />
                                                <ErrorMessage name="otherDesignation" component="div" className="text-error" />
                                            </bie.InputGroup>
                                        </bie.Col>
                                    )}

                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3}>
                                        <bie.InputGroup >
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>Employee Category </label>
                                            <Field as="select" name="employeeType" className="form-control mb-2" >
                                                <option value=''>--select--</option>
                                                {emp && emp.map((emp, i) => (
                                                    <option value={emp?.emp_type_id}>{emp?.emp_type_name}</option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="employeeType" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} >
                                        <bie.InputGroup>
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>Course he/she is teaching</label>
                                            <Field as="select" name="courseGroupCode" className="form-control mb-2">
                                                <option value=''>--select--</option>
                                                {course && course !== "No data found" && course.map((course, i) => (
                                                    <option value={course?.course_cat_id}>{course?.course_cat_name}</option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="courseGroupCode" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3}>
                                        <bie.InputGroup >
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>Date of Joining</label>
                                            <Field
                                                type="date"
                                                name="dateOfJoining"
                                                // min={formik.values.dateOfBirth.toISOString().split('T')[0]}
                                                min={(() => {
                                                    const dob = formik.values.dateOfBirth;
                                                    if (!dob) return undefined;
                                                    const dobDate = new Date(dob);
                                                    return dobDate.toISOString().split("T")[0];
                                                })()}
                                                className="form-control mb-2" onKeyDown={(e) => { e.preventDefault() }}
                                                max={new Date().toISOString().split('T')[0]}
                                            />
                                            <ErrorMessage name="dateOfJoining" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>


                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3}>
                                        <bie.InputGroup >
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>SSC Hall Ticket No </label>
                                            <Field type="text" name="sscNo" className="form-control mb-2" maxLength="12" placeholder='SSC Hall Ticket No'
                                            />
                                            <ErrorMessage name="sscNo" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} >
                                        <bie.InputGroup>
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>Qualified NET/SLET/SET</label>
                                            <div className='form-control'>
                                                <Field type="radio" name="qualifiedEts" value='true' />&nbsp;Yes&emsp;
                                                <Field type="radio" name="qualifiedEts" value='false' onClick={() => formik.setFieldValue(`qualifiedEtsPhoto`, '')} />&nbsp;No
                                            </div>
                                            <ErrorMessage name="qualifiedEts" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                    {formik.values.qualifiedEts === 'true' && (
                                        <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3}>
                                            <bie.InputGroup >
                                                <label classname='mb-1'><b style={{ color: 'red' }}>* </b>Upload Quailified NET/SLET/SET</label>
                                                <input type="file" name="qualifiedEtsPhoto" className="form-control mb-2" accept="image/*"
                                                    onChange={(e) => {
                                                        let filename = 'qualifiedEtsPhoto';
                                                        let path = "/Uploads/AffiliationPDFs/2024/";
                                                        ImagePdfBucket(e, formik, path, `qualifiedEtsPhoto`, filename, "image");

                                                    }}
                                                />
                                                <ErrorMessage name="qualifiedEtsPhoto" component="div" className="text-error" />
                                                {formik?.values?.qualifiedEtsPhoto && (<button type='button' style={{ color: "blue", textDecoration: "underline", }} onClick={() => viewImage(formik?.values?.qualifiedEtsPhoto)} className="btn btn-primary"> <FaEye size={20} /> </button>)}

                                            </bie.InputGroup>
                                        </bie.Col>
                                    )}
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3}>
                                        <bie.InputGroup >
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>Differently abled</label>
                                            <div className='form-control'>
                                                <Field type="radio" name="employeePwd" value="yes" />&nbsp;Yes&emsp;
                                                <Field type="radio" name="employeePwd" value="no" />&nbsp;No
                                            </div>
                                            <ErrorMessage name="employeePwd" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                </bie.Row>
                                <div className="inner-herbpage-service-title-sub"  >
                                    <h1 className="">Professional Experience Details</h1>
                                </div>
                                <bie.Row className="px-2 pt-2 m-0  ">
                                    <bie.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >

                                        <p className="field-mandotory">Do you have any Prior Working Experience</p>

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={2} xxl={2} >

                                        <Field type="radio" name="experience" value='true' />&nbsp;Yes&emsp;
                                        <Field type="radio" name="experience" value='false' onClick={() => formik.setFieldValue(`experiences`, [{
                                            slNo: '',
                                            organizationName: '',
                                            experienceType: '',
                                            institutionName: '',
                                            employmentFromYear: '',
                                            employmentToYear: '',
                                            designationHeld: '',
                                            yearsOfExperience: '',
                                            experienceDocumentPhoto: '',
                                        }])} />&nbsp;No
                                        <ErrorMessage name="experience" component="div" className="text-error" />
                                    </bie.Col>
                                    {formik?.values?.experience === 'true' && (
                                        <div className="table-responsive">
                                            <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                                <thead>
                                                    <tr>
                                                        <th>SNO</th>
                                                        <th>Name of the Organization</th>
                                                        <th>Experience Category</th>
                                                        <th>Name of the Institution / Organization</th>
                                                        <th>Employment From</th>
                                                        <th>Employment to</th>
                                                        <th>Designation held</th>
                                                        <th>Years of Employment</th>
                                                        <th>Upload Experience Certificate / Service Letter</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <FieldArray name="experiences">
                                                        {(ExperienceValues) => (
                                                            (ExperienceValues.form.values.experiences && ExperienceValues.form.values.experiences.length > 0
                                                                ? ExperienceValues.form.values.experiences
                                                                : [{}]
                                                            ).map((exp, index) => (
                                                                <tr key={index}>
                                                                    <td><center>{index + 1}</center></td>
                                                                    <td>
                                                                        <Field
                                                                            type="text" className="form-control mb-2"
                                                                            name={`experiences[${index}].organizationName`}
                                                                            placeholder="Organization Name" maxLength="80"
                                                                            onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)}
                                                                            onPaste={(e) => handleTestPaste(e)}
                                                                        />
                                                                        <ErrorMessage name={`experiences[${index}].organizationName`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <Field
                                                                            component="select"
                                                                            className="form-control mb-2"
                                                                            name={`experiences[${index}].experienceType`}>
                                                                            <option value="">--select--</option>
                                                                            <option value="T">Teaching</option>
                                                                            <option value="NT">Non Teaching</option>
                                                                        </Field>
                                                                        <ErrorMessage name={`experiences[${index}].experienceType`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <Field type="text" className="form-control mb-2"
                                                                            name={`experiences[${index}].institutionName`} maxLength="80"
                                                                            onPaste={(e) => handleTestPaste(e)}
                                                                            onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)}
                                                                            placeholder="Institution Name"
                                                                        />
                                                                        <ErrorMessage name={`experiences[${index}].institutionName`} component="div" className="text-error" />
                                                                    </td>
                                                                    {/* <td>
                                                                        <Field type="date" className="form-control mb-2" onKeyDown={(e) => { e.preventDefault() }}
                                                                            name={`experiences[${index}].employmentFromYear`}
                                                                            max={(() => {
                                                                                return new Date().toISOString().split("T")[0];
                                                                            })()}
                                                                            onClick={() => {
                                                                                if (!formik.values.experiences[index].employmentFromYear) {
                                                                                    formik.setFieldValue(`experiences[${index}].employmentToYear`, '');
                                                                                }
                                                                            }} />
                                                                        <ErrorMessage name={`experiences[${index}].employmentFromYear`} component="div" className="text-error" />
                                                                    </td> */}

                                                                    <Field
                                                                        type="date"
                                                                        className="form-control mb-2"
                                                                        name={`experiences[${index}].employmentFromYear`}
                                                                        max={new Date().toISOString().split("T")[0]}
                                                                        onKeyDown={(e) => e.preventDefault()}
                                                                        onChange={(e) => {
                                                                            const selectedDate = e.target.value;
                                                                            const allDates = formik.values.experiences.map((exp, i) => i !== index && exp.employmentFromYear);
                                                                            const isDuplicate = allDates.includes(selectedDate);

                                                                            if (isDuplicate) {
                                                                                Swal.fire({
                                                                                    icon: 'warning',
                                                                                    title: 'Duplicate Date',
                                                                                    text: `The date "${selectedDate}" is already selected in another row.`,
                                                                                    backdrop: false,
                                                                                }).then(() => {
                                                                                    formik.setFieldValue(`experiences[${index}].employmentFromYear`, '');
                                                                                });
                                                                            } else {
                                                                                formik.setFieldValue(`experiences[${index}].employmentFromYear`, selectedDate);
                                                                            }
                                                                        }}
                                                                        onClick={() => {
                                                                            if (!formik.values.experiences[index].employmentFromYear) {
                                                                                formik.setFieldValue(`experiences[${index}].employmentToYear`, '');
                                                                            }
                                                                        }}
                                                                    />
                                                                    <ErrorMessage name={`experiences[${index}].employmentFromYear`} component="div" className="text-error" />


                                                                    <td>
                                                                        <Field
                                                                            type="date" className="form-control mb-2" onKeyDown={(e) => { e.preventDefault() }}
                                                                            name={`experiences[${index}].employmentToYear`}
                                                                            min={formik.values.experiences[index]?.employmentFromYear || moment().subtract(1, 'days').format("YYYY-MM-DD")}

                                                                            onChange={(e) => {
                                                                                const selectedDate = e.target.value;
                                                                                const allDates = formik.values.experiences.map((exp, i) => i !== index && exp.employmentToYear);
                                                                                const isDuplicate = allDates.includes(selectedDate);

                                                                                if (isDuplicate) {
                                                                                    Swal.fire({
                                                                                        icon: 'warning',
                                                                                        title: 'Duplicate Date',
                                                                                        text: `The date "${selectedDate}" is already selected in another row.`,
                                                                                        backdrop: false,
                                                                                    }).then(() => {
                                                                                        formik.setFieldValue(`experiences[${index}].employmentToYear`, '');
                                                                                    });
                                                                                } else {
                                                                                    formik.setFieldValue(`experiences[${index}].employmentToYear`, selectedDate);
                                                                                }
                                                                            }}
                                                                        />
                                                                        <ErrorMessage name={`experiences[${index}].employmentToYear`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <Field type="text" className="form-control mb-2" name={`experiences[${index}].designationHeld`}
                                                                            onPaste={(e) => handleTestPaste(e)} placeholder="Designation" onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)} />
                                                                        <ErrorMessage name={`experiences[${index}].designationHeld`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <Field type="text" className="form-control mb-2" name={`experiences[${index}].yearsOfExperience`}
                                                                            placeholder="Years of Experience" onPaste={(e) => handlePaste(e)}
                                                                            onKeyPress={(e) => AllowFloats(e)} />
                                                                        <ErrorMessage name={`experiences[${index}].yearsOfExperience`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <bie.Row>
                                                                            <bie.Col xs={12} sm={12} md={12} lg={7} xl={7} xxl={7} className='mb-2'>
                                                                                <bie.InputGroup>
                                                                                    <input type="file" className="form-control mb-2" name={`experiences[${index}].experienceDocumentPhoto`} accept="application/pdf"
                                                                                        onChange={(e) => {
                                                                                            let filename = `experiences_experienceDocumentPhoto_upload`;
                                                                                            let path = "/Uploads/AffiliationPDFs/2024/";
                                                                                            ImagePdfBucket(e, formik, path, `experiences[${index}].experienceDocumentPhoto`, filename, "pdf");
                                                                                        }} />
                                                                                    <Field type="hidden" name={`experiences[${index}].experienceDocumentPhoto`} className="form-control mb-2" />
                                                                                    <ErrorMessage name={`experiences[${index}].experienceDocumentPhoto`} component="div" className="text-error" />
                                                                                </bie.InputGroup>
                                                                            </bie.Col>
                                                                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className='mb-2'>
                                                                                {formik?.values?.experiences?.[index]?.experienceDocumentPhoto &&
                                                                                    formik?.values?.experiences?.[index]?.experienceDocumentPhoto !== "0" &&
                                                                                    (
                                                                                        <button type='button' className="btn btn-primary" onClick={() => { viewImage(formik?.values?.experiences?.[index]?.experienceDocumentPhoto) }}>
                                                                                            <FaEye size={20} />
                                                                                        </button>
                                                                                    )
                                                                                }


                                                                            </bie.Col>
                                                                        </bie.Row>
                                                                    </td>
                                                                    <td align="center">
                                                                        {index === 0 ? (
                                                                            <button
                                                                                type="button"
                                                                                className="button-titile btn btn-sm btn-success"
                                                                                onClick={() => {
                                                                                    ExperienceValues.push({
                                                                                        organizationName: '',
                                                                                        experienceType: '',
                                                                                        institutionName: '',
                                                                                        employmentFromYear: '',
                                                                                        employmentToYear: '',
                                                                                        designationHeld: '',
                                                                                        yearsOfExperience: '',
                                                                                        experienceDocumentPhoto: '',
                                                                                    });
                                                                                }}
                                                                            >
                                                                                <VscDiffAdded></VscDiffAdded>{" "}
                                                                            </button>
                                                                        ) : ""}
                                                                        {index !== 0 && index === formik?.values?.experiences?.length - 1 ? (
                                                                            <button
                                                                                type="button"
                                                                                className="button-titile btn btn-sm btn-danger"
                                                                                onClick={() => ExperienceValues.remove(index)}
                                                                            >
                                                                                <BiTrash></BiTrash>
                                                                            </button>
                                                                        ) : ""}
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        )}
                                                    </FieldArray>
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </bie.Row>

                                <div className="inner-herbpage-service-title-sub pt-0"  >
                                    <h1 className="">Educational Qualification</h1>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                        <thead>
                                            <tr>
                                                <th>SNO</th>
                                                <th>Course</th>
                                                <th>Specialization</th>
                                                <th>Certificate Number</th>
                                                <th>Percentage of Marks</th>
                                                <th>Year of Completion<br />(dd/mm/yyyy)</th>
                                                <th>University Location</th>
                                                <th>University Name</th>
                                                <th>Upload Certificate</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <FieldArray name="qualifications">
                                                {(QualificationValues) => {
                                                    return QualificationValues?.form?.values?.qualifications?.map((qual, index) => {
                                                        return (
                                                            <>

                                                                <tr key={index}>
                                                                    <td>
                                                                        <center>{index + 1}</center>
                                                                    </td>
                                                                    <td>
                                                                        <Field
                                                                            as="select"
                                                                            className="form-control mb-2"
                                                                            name={`qualifications[${index}].qualificationId`}
                                                                            placeholder="Qualification ID"
                                                                            onChange={(e) => GetSpecializations(e.target.value, index)}
                                                                        >
                                                                            <option value=''>--select--</option>
                                                                            {quall && qual !== "No data found" && quall?.map((quals, i) => (
                                                                                <option value={quals?.course_cat_id}>{quals?.course_cat_name}</option>
                                                                            ))}
                                                                            {quall && <option value='999'>Others</option>}
                                                                        </Field>
                                                                        <ErrorMessage name={`qualifications[${index}].qualificationId`} component="div" className="text-error" />
                                                                        {formik?.values?.qualifications[index]?.qualificationId === '999' &&
                                                                            <>
                                                                                <Field type="text" className="form-control mb-2 mt-1" name={`qualifications[${index}].otherCourse`}
                                                                                    placeholder="Other Course" />
                                                                                <ErrorMessage name={`qualifications[${index}].otherCourse`} component="div" className="text-error" />
                                                                            </>}
                                                                    </td>
                                                                    <td>
                                                                        <Field as="select" className="form-control mb-2" name={`qualifications[${index}].specializationCode`}
                                                                            onChange={(e) => formik.setFieldValue(`qualifications[${index}].otherSpecialization`, '')}>
                                                                            <option value=''>--select--</option>
                                                                            {spec[index] && spec[index].map((sp, i) => (
                                                                                <option key={i} value={sp?.specialization_id}>{sp?.specialization_name}</option>
                                                                            ))}
                                                                            {spec[index] && <option value='999'>Others</option>}
                                                                        </Field>
                                                                        <ErrorMessage name={`qualifications[${index}].specializationCode`}
                                                                            component="div" className="text-error" />
                                                                        {spec[index] && formik?.values?.qualifications[index]?.specializationCode === '999' && (
                                                                            <>
                                                                                <Field
                                                                                    type="text"
                                                                                    className="form-control mb-2 mt-1"
                                                                                    name={`qualifications[${index}].otherSpecialization`}
                                                                                    placeholder="Other Specialization"
                                                                                />
                                                                                <ErrorMessage name={`qualifications[${index}].otherSpecialization`} component="div" className="text-error" />
                                                                            </>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        <Field
                                                                            type="text"
                                                                            className="form-control mb-2"
                                                                            name={`qualifications[${index}].certificateNo`}
                                                                            placeholder="Certificate No"
                                                                            maxLength="15"
                                                                        />
                                                                        <ErrorMessage name={`qualifications[${index}].certificateNo`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <Field type="text" className="form-control mb-2" name={`qualifications[${index}].percentage`}
                                                                            placeholder="Percentage" onPaste={(e) => handlePaste(e)}
                                                                            onKeyPress={(e) => AllowFloats(e, "percentage")}
                                                                        />
                                                                        <ErrorMessage name={`qualifications[${index}].percentage`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <Field type="date" className="form-control mb-2" onKeyDown={(e) => { e.preventDefault() }} name={`qualifications[${index}].passedYear`}
                                                                            min={formik.values.dateOfBirth ? (() => {
                                                                                const dob = new Date(formik.values.dateOfBirth);
                                                                                dob.setFullYear(dob.getFullYear() + 12); // Add 21 years to dateOfBirth
                                                                                return dob.toISOString().split("T")[0]; // Format as YYYY-MM-DD
                                                                            })()
                                                                                : ""}

                                                                            onChange={(e) => {
                                                                                const selectedDate = e.target.value;
                                                                                const allDates = formik.values.qualifications.map((exp, i) => i !== index && exp.passedYear);
                                                                                const isDuplicate = allDates.includes(selectedDate);

                                                                                if (isDuplicate) {
                                                                                    Swal.fire({
                                                                                        icon: 'warning',
                                                                                        title: 'Duplicate Date',
                                                                                        text: `The date "${selectedDate}" is already selected in another row.`,
                                                                                        backdrop: false,
                                                                                    }).then(() => {
                                                                                        formik.setFieldValue(`qualifications[${index}].passedYear`, '');
                                                                                    });
                                                                                } else {
                                                                                    formik.setFieldValue(`qualifications[${index}].passedYear`, selectedDate);
                                                                                }
                                                                            }}
                                                                        />
                                                                        <ErrorMessage name={`qualifications[${index}].passedYear`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <Field as="select" className="form-control mb-2"
                                                                            name={`qualifications[${index}].universityLocation`}>
                                                                            <option value=''>--Select--</option>
                                                                            <option value='Within Ap'>Within AP</option>
                                                                            <option value='Outside Ap'>Outside AP</option>

                                                                        </Field>


                                                                        <ErrorMessage name={`qualifications[${index}].universityLocation`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <Field
                                                                            type="text"
                                                                            className="form-control mb-2"
                                                                            name={`qualifications[${index}].universityName`}
                                                                            placeholder="University Name" onPaste={(e) => handleTestPaste(e)}
                                                                            onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)}
                                                                            maxLength="80"
                                                                        />
                                                                        <ErrorMessage name={`qualifications[${index}].universityName`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <bie.Row>
                                                                            <bie.Col xs={12} sm={12} md={12} lg={9} xl={9} xxl={9} className=''>
                                                                                <bie.InputGroup>
                                                                                    <input type="file" className="form-control mb-2" accept="application/pdf"
                                                                                        name={`qualifications[${index}].qualificationDocumentPhoto`}
                                                                                        onChange={(e) => {
                                                                                            let filename = `qualifications_qualificationDocumentPhoto_upload`;
                                                                                            let path = "/Uploads/AffiliationPDFs/2024/";
                                                                                            ImagePdfBucket(e, formik, path, `qualifications[${index}].qualificationDocumentPhoto`, filename, "pdf");
                                                                                        }}
                                                                                    />
                                                                                    <ErrorMessage name={`qualifications[${index}].qualificationDocumentPhoto`} component="div" className="text-error" />

                                                                                </bie.InputGroup>
                                                                            </bie.Col>

                                                                            <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className=''>
                                                                                {formik?.values?.qualifications[index]?.qualificationDocumentPhoto && <button type='button' className="btn btn-primary" onClick={() => { viewImage(formik?.values?.qualifications[index]?.qualificationDocumentPhoto) }}><FaEye size={20} /> </button>}

                                                                            </bie.Col>
                                                                        </bie.Row>
                                                                    </td>
                                                                    <td align="center">
                                                                        {index === 0 ? (
                                                                            <button
                                                                                type="button"
                                                                                className="button-titile btn btn-sm btn-success"
                                                                                onClick={() => {
                                                                                    QualificationValues.push({
                                                                                        qualificationId: '',
                                                                                        specializationCode: '',
                                                                                        certificateNo: '',
                                                                                        percentage: '',
                                                                                        passedYear: '',
                                                                                        universityName: '',
                                                                                        qualificationDocumentPhoto: '',
                                                                                        otherCourse: '',
                                                                                        otherSpecialization: '',
                                                                                        universityLocation: ''
                                                                                    });
                                                                                }}
                                                                            >
                                                                                <VscDiffAdded></VscDiffAdded>{" "}
                                                                            </button>
                                                                        ) : ""}
                                                                        {index !== 0 && index === formik?.values?.qualifications?.length - 1 ? (
                                                                            <button
                                                                                type="button"
                                                                                className="button-titile btn btn-sm btn-danger"
                                                                                onClick={() => QualificationValues.remove(index)}
                                                                            >
                                                                                <BiTrash></BiTrash>
                                                                            </button>
                                                                        ) : ""}
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        );
                                                    });
                                                }}
                                            </FieldArray>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="inner-herbpage-service-title-sub pt-0"  >
                                    <h1 className="">Membership of Scientific-research, Industrial etc Details</h1>
                                </div>
                                <bie.Row className="px-2 pt-2 m-0  ">
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={5} xxl={2} className="mb-3">
                                        <label classname='mb-1' className="field-mandotory">Any Membership available</label>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={2} xxl={2} >
                                        <Field type="radio" name="articlesPatents" value='true' />&nbsp;Yes&emsp;
                                        <Field type="radio" name="articlesPatents" value='false' onChange={() => formik.setFieldValue(`memberships`, [{
                                            membershipName: '',
                                            membershipId: '',
                                            membershipFromYear: '',
                                            membershipDocPhoto: '',
                                        }])} />&nbsp;No

                                        <ErrorMessage name="articlesPatents" component="div" className="text-error" />

                                    </bie.Col>

                                    {formik.values.articlesPatents === 'true' && (
                                        <div className="table-responsive">
                                            <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                                <thead>
                                                    <tr>
                                                        <th>SNO</th>
                                                        <th>Membership with Body<br />/Organization Name</th>
                                                        <th>Membership Id</th>
                                                        <th>Membership from</th>
                                                        <th>Upload Association/ Membership certificate</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <FieldArray name="memberships">
                                                        {(MembershipValues) => (
                                                            (MembershipValues.form.values.memberships && MembershipValues.form.values.memberships.length > 0
                                                                ? MembershipValues.form.values.memberships
                                                                : [{}]
                                                            ).map((member, index) => (
                                                                <tr key={index}>
                                                                    <td><center>{index + 1}</center></td>
                                                                    <td>
                                                                        <Field
                                                                            type="text"
                                                                            className="form-control mb-2"
                                                                            name={`memberships[${index}].membershipName`}
                                                                            placeholder="Membership Name"
                                                                            maxLength="80" onPaste={(e) => handleTestPaste(e)}
                                                                            onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)}
                                                                        />
                                                                        <ErrorMessage name={`memberships[${index}].membershipName`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <Field
                                                                            type="text"
                                                                            className="form-control mb-2" maxLength="10"
                                                                            name={`memberships[${index}].membershipId`}
                                                                            placeholder="Membership ID" onPaste={(e) => handlePaste(e)}
                                                                            onKeyPress={(e) => allowNumbersOnly(e)}
                                                                        />
                                                                        <ErrorMessage name={`memberships[${index}].membershipId`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <Field
                                                                            type="date" onKeyDown={(e) => { e.preventDefault() }}
                                                                            className="form-control mb-2"
                                                                            name={`memberships[${index}].membershipFromYear`}
                                                                            min={
                                                                                formik.values.dateOfBirth
                                                                                    ? (() => {
                                                                                        const dob = new Date(formik.values.dateOfBirth);
                                                                                        dob.setFullYear(dob.getFullYear() + 15); // Add 21 years to dateOfBirth
                                                                                        return dob.toISOString().split("T")[0]; // Format as YYYY-MM-DD
                                                                                    })()
                                                                                    : ""}

                                                                            onChange={(e) => {
                                                                                const selectedDate = e.target.value;
                                                                                const allDates = formik.values.memberships.map((exp, i) => i !== index && exp.membershipFromYear);
                                                                                const isDuplicate = allDates.includes(selectedDate);

                                                                                if (isDuplicate) {
                                                                                    Swal.fire({
                                                                                        icon: 'warning',
                                                                                        title: 'Duplicate Date',
                                                                                        text: `The date "${selectedDate}" is already selected in another row.`,
                                                                                        backdrop: false,
                                                                                    }).then(() => {
                                                                                        formik.setFieldValue(`memberships[${index}].membershipFromYear`, '');
                                                                                    });
                                                                                } else {
                                                                                    formik.setFieldValue(`memberships[${index}].membershipFromYear`, selectedDate);
                                                                                }
                                                                            }}
                                                                        />
                                                                        <ErrorMessage name={`memberships[${index}].membershipFromYear`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <bie.Row>
                                                                            <bie.Col xs={12} sm={12} md={12} lg={9} xl={9} xxl={9} className=''>
                                                                                <bie.InputGroup>
                                                                                    <input
                                                                                        type="file" className="form-control mb-2" name={`memberships[${index}].membershipDocPhoto`} accept="application/pdf"
                                                                                        onChange={(e) => {
                                                                                            let filename = `memberships_membershipDocPhoto_upload`;
                                                                                            let path = "/Uploads/AffiliationPDFs/2024/";
                                                                                            ImagePdfBucket(e, formik, path, `memberships[${index}].membershipDocPhoto`, filename, "pdf");
                                                                                        }}
                                                                                    />

                                                                                    <ErrorMessage name={`memberships[${index}].membershipDocPhoto`} component="div" className="text-error" />
                                                                                </bie.InputGroup>
                                                                            </bie.Col>
                                                                            <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-2'>
                                                                                {formik?.values?.memberships[index]?.membershipDocPhoto && <button type='button' className="btn btn-primary" onClick={() => { viewImage(formik?.values?.memberships[index]?.membershipDocPhoto) }}><FaEye size={20} /> </button>}

                                                                            </bie.Col>
                                                                        </bie.Row>

                                                                    </td>
                                                                    <td align="center">
                                                                        {index === 0 ? (
                                                                            <button
                                                                                type="button"
                                                                                className="button-titile btn btn-sm btn-success"
                                                                                onClick={() => {
                                                                                    MembershipValues.push({
                                                                                        membershipName: '',
                                                                                        membershipId: '',
                                                                                        membershipFromYear: '',
                                                                                        membershipDocPhoto: ''
                                                                                    });
                                                                                }}
                                                                            >
                                                                                <VscDiffAdded></VscDiffAdded>{" "}
                                                                            </button>
                                                                        ) : ""}
                                                                        {index !== 0 && index === formik?.values?.memberships?.length - 1 ? (
                                                                            <button
                                                                                type="button"
                                                                                className="button-titile btn btn-sm btn-danger"
                                                                                onClick={() => MembershipValues.remove(index)}
                                                                            >
                                                                                <BiTrash></BiTrash>
                                                                            </button>
                                                                        ) : ""}
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        )}
                                                    </FieldArray>
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </bie.Row>

                                <div className="inner-herbpage-service-title-sub pt-0"  >
                                    <h1 className="">Teaching Staff Details</h1>
                                </div>
                                <bie.Row className="px-2 my-3">
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} >
                                        <bie.InputGroup >
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>No.of P.HD's Registered</label>
                                            <Field type="text" name="noPhdReg" className="form-control mb-2" maxLength="4" placeholder={`No.of P.HD's Registered`}
                                                onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="noPhdReg" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} >
                                        <bie.InputGroup >
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>No.of P.HD's Awarded</label>
                                            <Field type="text" name="noPhdAwarded" className="form-control mb-2" maxLength="4" placeholder={`No.of P.HD's Awarded`}
                                                onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="noPhdAwarded" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col> <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} >
                                        <bie.InputGroup >
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>No.Of Articles Published</label>
                                            <Field type="text" name="articlesPublished" className="form-control mb-2 " maxLength="4" placeholder={`No.Of Articles Published`}
                                                onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="articlesPublished" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col> <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} >
                                        <bie.InputGroup >
                                            <label classname='mb-1'><b style={{ color: 'red' }}>* </b>No.Of Patent Rights Granted</label>
                                            <Field type="text" name="patentsGranted" className="form-control mb-2" maxLength="4" placeholder={`No.Of Patent Rights Granted`}
                                                onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="patentsGranted" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                </bie.Row>
                                <button type='submit' className='btn btn-success btn-sm mt-2 float-end'>{changebuttonname}</button>

                            </bie.Container>
                        </Form>
                    </FormikProvider>
                </bie.Container >
            </div>
        </>
    )
}